import "core-js/modules/es.array.reduce.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { SCALE_CHANNELS, SHAPE } from '../../channel';
import { hasConditionalFieldDef, isFieldDef } from '../../channeldef';
import { GEOSHAPE } from '../../mark';
import { NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES, scaleCompatible, scaleTypePrecedence } from '../../scale';
import { GEOJSON } from '../../type';
import { keys } from '../../util';
import { isUnitModel } from '../model';
import { defaultScaleResolve } from '../resolve';
import { mergeValuesWithExplicit, tieBreakByComparing } from '../split';
import { ScaleComponent } from './component';
import { parseScaleDomain } from './domain';
import { parseScaleProperty, parseScaleRange } from './properties';
import { scaleType } from './type';
export function parseScales(model) {
  parseScaleCore(model);
  parseScaleDomain(model);

  var _iterator = _createForOfIteratorHelper(NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      parseScaleProperty(model, prop);
    } // range depends on zero

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  parseScaleRange(model);
}
export function parseScaleCore(model) {
  if (isUnitModel(model)) {
    model.component.scales = parseUnitScaleCore(model);
  } else {
    model.component.scales = parseNonUnitScaleCore(model);
  }
}
/**
 * Parse scales for all channels of a model.
 */

function parseUnitScaleCore(model) {
  var encoding = model.encoding,
      mark = model.mark;
  return SCALE_CHANNELS.reduce(function (scaleComponents, channel) {
    var fieldDef;
    var specifiedScale;
    var channelDef = encoding[channel]; // Don't generate scale for shape of geoshape

    if (isFieldDef(channelDef) && mark === GEOSHAPE && channel === SHAPE && channelDef.type === GEOJSON) {
      return scaleComponents;
    }

    if (isFieldDef(channelDef)) {
      fieldDef = channelDef;
      specifiedScale = channelDef.scale;
    } else if (hasConditionalFieldDef(channelDef)) {
      // Need to specify generic for hasConditionalFieldDef as the value type can vary across channels
      fieldDef = channelDef.condition;
      specifiedScale = channelDef.condition['scale']; // We use ['scale'] since we know that channel here has scale for sure
    }

    if (fieldDef && specifiedScale !== null && specifiedScale !== false) {
      specifiedScale = specifiedScale || {};
      var sType = scaleType(specifiedScale, channel, fieldDef, mark);
      scaleComponents[channel] = new ScaleComponent(model.scaleName(channel + '', true), {
        value: sType,
        explicit: specifiedScale.type === sType
      });
    }

    return scaleComponents;
  }, {});
}

var scaleTypeTieBreaker = tieBreakByComparing(function (st1, st2) {
  return scaleTypePrecedence(st1) - scaleTypePrecedence(st2);
});

function parseNonUnitScaleCore(model) {
  var scaleComponents = model.component.scales = {};
  var scaleTypeWithExplicitIndex = {};
  var resolve = model.component.resolve; // Parse each child scale and determine if a particular channel can be merged.

  var _iterator2 = _createForOfIteratorHelper(model.children),
      _step2;

  try {
    var _loop = function _loop() {
      var child = _step2.value;
      parseScaleCore(child); // Instead of always merging right away -- check if it is compatible to merge first!

      keys(child.component.scales).forEach(function (channel) {
        // if resolve is undefined, set default first
        resolve.scale[channel] = resolve.scale[channel] || defaultScaleResolve(channel, model);

        if (resolve.scale[channel] === 'shared') {
          var explicitScaleType = scaleTypeWithExplicitIndex[channel];
          var childScaleType = child.component.scales[channel].getWithExplicit('type');

          if (explicitScaleType) {
            if (scaleCompatible(explicitScaleType.value, childScaleType.value)) {
              // merge scale component if type are compatible
              scaleTypeWithExplicitIndex[channel] = mergeValuesWithExplicit(explicitScaleType, childScaleType, 'type', 'scale', scaleTypeTieBreaker);
            } else {
              // Otherwise, update conflicting channel to be independent
              resolve.scale[channel] = 'independent'; // Remove from the index so they don't get merged

              delete scaleTypeWithExplicitIndex[channel];
            }
          } else {
            scaleTypeWithExplicitIndex[channel] = childScaleType;
          }
        }
      });
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    } // Merge each channel listed in the index

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  keys(scaleTypeWithExplicitIndex).forEach(function (channel) {
    // Create new merged scale component
    var name = model.scaleName(channel, true);
    var typeWithExplicit = scaleTypeWithExplicitIndex[channel];
    scaleComponents[channel] = new ScaleComponent(name, typeWithExplicit); // rename each child and mark them as merged

    var _iterator3 = _createForOfIteratorHelper(model.children),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var child = _step3.value;
        var childScale = child.component.scales[channel];

        if (childScale) {
          child.renameScale(childScale.get('name'), name);
          childScale.merged = true;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  });
  return scaleComponents;
}